var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "text-right" }, [
        !_vm.loading
          ? _c(
              "button",
              {
                staticClass: "btn btn-outline-info",
                on: { click: _vm.getPayments },
              },
              [_vm._v("Обновить оплаты")]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("pulse-loader", {
        staticClass: "text-center",
        attrs: { loading: _vm.loading, color: _vm.$constants.LOADING_COLOR },
      }),
      _vm._v(" "),
      _vm.records
        ? [
            _c("table", { staticClass: "table table-sm table-hover mt-0" }, [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "tbody",
                [
                  _vm._l(_vm.groups, function (g, i) {
                    return [
                      _c(
                        "tr",
                        {
                          staticClass: "pointer",
                          on: {
                            click: function ($event) {
                              return _vm.showDetails(i)
                            },
                          },
                        },
                        [
                          _c(
                            "td",
                            { attrs: { colspan: "10" } },
                            [
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.printDate(
                                      Object.values(g)[0].records[0].pay_date
                                    )
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _vm._l(g, function (r, uId) {
                                return _c("p", [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(r.total.toLocaleString("ru-RU"))
                                    ),
                                  ]),
                                  _vm._v(
                                    " -\n              " +
                                      _vm._s(_vm.users[uId]?.name ?? uId) +
                                      "\n            "
                                  ),
                                ])
                              }),
                            ],
                            2
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.displayDetails[i]
                        ? [
                            _vm._l(g, function (gr, id) {
                              return _vm._l(gr.records, function (r, ii) {
                                return _c("tr", [
                                  _c("td", [_vm._v(_vm._s(ii + 1))]),
                                  _vm._v(" "),
                                  _c("td", [_vm._v(_vm._s(r.id))]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(r.sum.toLocaleString("ru-RU"))
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(_vm._s(_vm.users[r.user_id]?.name)),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [_vm._v(_vm._s(r.comment))]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(_vm._s(_vm.printDate(r.pay_date))),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        (r.income?.sum ?? 0).toLocaleString(
                                          "ru-RU"
                                        )
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(_vm._s(r.income?.user?.name)),
                                  ]),
                                ])
                              })
                            }),
                          ]
                        : _vm._e(),
                    ]
                  }),
                ],
                2
              ),
            ]),
          ]
        : _vm._e(),
      _vm._v(" "),
      !_vm.loading && !_vm.records
        ? [_c("h5", [_vm._v("Выплаты не найдены")])]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("#")]),
        _vm._v(" "),
        _c("th", [_vm._v("id")]),
        _vm._v(" "),
        _c("th", [_vm._v("сумма")]),
        _vm._v(" "),
        _c("th", [_vm._v("агент")]),
        _vm._v(" "),
        _c("th", [_vm._v("комментарий")]),
        _vm._v(" "),
        _c("th", [_vm._v("дата")]),
        _vm._v(" "),
        _c("th", [_vm._v("инкассация")]),
        _vm._v(" "),
        _c("th", [_vm._v("курьер")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }